import ativos from './ativos-rules';
import bmg from './bmg-rules';
import c6 from './c6-rules';
import carrefour from './carrefour-rules';
import cielo from './cielo-rules';
import credsystem from './credsystem-rules';
import inter from './inter-rules';
import itau from './itau-rules';
import mercadolivre from './mercadolivre-rules';
import midway from './midway-rules';
import neon from './neon-rules';
import nubank from './nubank-rules';
import recovery from './recovery-rules';
import returnRules from './return-rules';
import standard from './standard-rules';
import pan from './pan-rules';
import santander from './santander-rules';

export default {
  standard,
  ativos,
  bmg,
  c6,
  midway,
  carrefour,
  inter,
  itau,
  recovery,
  return: returnRules,
  mercadolivre,
  neon,
  nubank,
  credsystem,
  cielo,
  pan,
  santander,
  Santander: santander,
};
